import PropTypes from 'prop-types';
import React from 'react';

import Cta from '../../atoms/cta/cta';
import './match-cta-row.scss';
import { IClassNames, makeClassNames } from '../../../utils/styles';

const classNames = (): IClassNames =>
  makeClassNames({
    matchCtaRow: 'match-cta-row',
    td: 'match-cta-row__td',
  });

export interface IMatchCtaRow {
  children: React.ReactNode;
  href: string;
}

const MatchCtaRow: React.FC<IMatchCtaRow> = ({ children, href }) => {
  const cn = classNames();

  return (
    <tr className={cn.matchCtaRow}>
      <td className={cn.td} colSpan={100}>
        <Cta href={href} iconPosition="right" mobileButton>
          {children}
        </Cta>
      </td>
    </tr>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  MatchCtaRow.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string.isRequired,
  };
}

export default MatchCtaRow;
